import cs from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, DownLineIcon, Flex, Popover, Select, Text } from 'ui';

type FilterState = {
  sort: string;
  type: string[];
};

type P = {
  filter: FilterState;
  filterPosts: (sort: Partial<FilterState>) => void;
  selected: boolean;
  setFilter: (value: string[]) => void;
};

const ProgramTopicFilter = ({ filter, filterPosts, selected, setFilter }: P) => {
  const { t } = useTranslation();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const filterOptions = [
    { label: t('Activities'), value: 'activity' },
    { label: t('Events'), value: 'event' },
    { label: t('Polls'), value: 'poll' },
    { label: t('Posts'), value: 'post' },
    { label: t('Withings order'), value: 'withings_order_post' },
  ];

  const sortOptions = [
    { label: t('Date created'), value: 'date_created' },
    { label: t('Alphabetically'), value: 'name' },
    { label: t('Content type'), value: 'type' },
  ];

  return (
    <Flex className={cs('program-topic-filter', { 'program-topic-filter--selected': selected })} gap="xs">
      <Flex flex={1} vertical>
        <Text size="small" weight="bold">
          Sort By
        </Text>
        <Select
          onChange={(value) => {
            filterPosts({ sort: value });
          }}
          options={sortOptions}
          placeholder={t('Default')}
          value={filter.sort}
        />
      </Flex>
      <Flex className="program-topic-filter__filter" flex={1} vertical>
        <Text size="small" weight="bold">
          Filter by category
        </Text>
        <Popover
          content={
            <Checkbox.Group
              className="program-topic-filter__checkboxes"
              onChange={(value) => {
                setFilter(value);
              }}
              options={filterOptions}
              value={filter.type}
            />
          }
          onOpenChange={setIsFilterOpen}
          open={isFilterOpen}
          placement="bottom"
          trigger="click"
        >
          <Button>
            <DownLineIcon />
          </Button>
        </Popover>
      </Flex>
    </Flex>
  );
};

export default ProgramTopicFilter;
